import { useAccountFilterStore } from './accountStore'
import { useAccreditationFilterStore } from './accreditationStore'
import { useAdminUserFilterStore } from './adminUserStore'
import { useAllFundFilterStore } from './allFundStore'
import { useAssessorFilterStore } from './assessorStore'
import { useClientFilterStore } from './clientStore'
import { organizationFileRepositoryFilterStore } from './fileRepositoryStore'
import { useFundFilterStore } from './fundStore'
import { useManagerFilterStore } from './managerStore'
import { useOrganisationFilterStore } from './OrganisationStore'
import { useReportFundFilterStore } from './reportFundStore'
import { useReportJobQueryFilterStore } from './reportJobQueryStore'
import { useReportJobFilterStore } from './reportJobStore'
import { useReportLogFilterStore } from './reportLogStore'
import { useRequestAccessFilterStore } from './requestAccess'
import { useRequestedAccessFilterStore } from './requestedAccess'
import { useUserLogFilterStore } from './userLogStore'
import { useNotificationFilterStore } from './NotificationStore'

export function useClearFilter(type?: string) {
  const accountStore = useAccountFilterStore()
  const accreditationStore = useAccreditationFilterStore()
  const adminUserStore = useAdminUserFilterStore()
  const assessorStore = useAssessorFilterStore()
  const organisationStore = useOrganisationFilterStore()
  const organisationFileStore = organizationFileRepositoryFilterStore()
  const managerStore = useManagerFilterStore()
  const clientStore = useClientFilterStore()
  const userLogStore = useUserLogFilterStore()
  const requestAccessStore = useRequestAccessFilterStore()
  const requestedAccessStore = useRequestedAccessFilterStore()
  const reportStore = useReportFundFilterStore()
  const reportJobStore = useReportJobFilterStore()
  const reportLogStore = useReportLogFilterStore()
  const reportJobQueryStore = useReportJobQueryFilterStore()
  const allFundsFilterStore = useAllFundFilterStore()
  const fundsFilterStore = useFundFilterStore()

  const stores = [
    {
      store: accountStore,
      clearFilter: 'clearAccountFilter',
      clearRows: 'clearSelectedRows',
      clearAdvacneFilter: 'clearAdvanceFilter',
    },
    {
      store: requestAccessStore,
      clearFilter: 'clearRequestAccessFilter',
      clearRows: 'clearSelectedRows',
      clearAdvacneFilter: 'clearAdvanceFilter',
    },
    {
      store: reportStore,
      clearFilter: 'clearReportFundFilter',
      clearRows: 'clearSelectedRows',
      clearAdvacneFilter: 'clearAdvanceFilter',
    },
    {
      store: reportJobStore,
      clearFilter: 'clearReportJobFilter',
      clearRows: 'clearSelectedRows',
      clearAdvacneFilter: 'clearAdvanceFilter',
    },
    {
      store: reportLogStore,
      clearFilter: 'clearReportLogFilter',
      clearRows: 'clearSelectedRows',
      clearAdvacneFilter: 'clearAdvanceFilter',
    },
    {
      store: reportJobQueryStore,
      clearFilter: 'clearReportJobQueryFilter',
      clearRows: 'clearSelectedRows',
      clearAdvacneFilter: 'clearAdvanceFilter',
    },
    {
      store: allFundsFilterStore,
      clearFilter: 'clearAllFundFilter',
      clearRows: 'clearSelectedRows',
      clearAdvacneFilter: 'clearAdvanceFilter',
    },
    {
      store: fundsFilterStore,
      clearFilter: 'clearFundFilter',
      clearRows: 'clearSelectedRows',
      clearAdvacneFilter: 'clearAdvanceFilter',
    },
    {
      store: requestedAccessStore,
      clearFilter: 'clearRequestedAccessFilter',
      clearRows: 'clearSelectedRows',
      clearAdvacneFilter: 'clearAdvanceFilter',
    },
    {
      store: accreditationStore,
      clearFilter: 'clearAccreditationFilter',
      clearRows: 'clearSelectedRows',
      clearAdvacneFilter: 'clearAdvanceFilter',
    },
    {
      store: useNotificationFilterStore(),
      clearFilter: 'clearNotificationFilter',
      clearRows: 'clearSelectedRows',
      clearAdvacneFilter: 'clearAdvanceFilter',
    },
    {
      store: adminUserStore,
      clearFilter: 'clearAdminUserFilter',
      clearRows: 'clearSelectedRows',
      clearAdvacneFilter: 'clearAdvanceFilter',
    },
    {
      store: managerStore,
      clearFilter: 'clearManagerFilter',
      clearRows: 'clearSelectedRows',
      clearAdvacneFilter: 'clearAdvanceFilter',
    },
    {
      store: clientStore,
      clearFilter: 'clearClientFilter',
      clearRows: 'clearSelectedRows',
      clearAdvacneFilter: 'clearAdvanceFilter',
    },
    {
      store: userLogStore,
      clearFilter: 'clearClientFilter',
      clearRows: 'clearSelectedRows',
      clearAdvacneFilter: 'clearAdvanceFilter',
    },
    {
      store: assessorStore,
      clearFilter: 'clearAssessorFilter',
      clearRows: 'clearSelectedRows',
      clearAdvacneFilter: 'clearAdvanceFilter',
    },
    {
      store: organisationStore,
      clearFilter: 'clearOrganisationFilter',
      clearRows: 'clearSelectedRows',
      clearAdvacneFilter: 'clearAdvanceFilter',
    },
    {
      store: organisationFileStore,
      clearFilter: 'clearOrgFileFilter',
      clearRows: 'clearSelectedRows',
      clearAdvacneFilter: 'clearAdvanceFilter',
    },
  ]

  if (type == 'filter_only') {
    return () => {
      stores.forEach(({ store, clearFilter, clearAdvacneFilter }) => {
        if (typeof (store as any)[clearFilter] === 'function') {
          ;(store as any)[clearFilter]('from_filter')
        }
        if (typeof (store as any)[clearAdvacneFilter] === 'function') {
          ;(store as any)[clearAdvacneFilter]()
        }
      })
    }
  } else {
    return () => {
      stores.forEach(
        ({ store, clearFilter, clearRows, clearAdvacneFilter }) => {
          if (typeof (store as any)[clearFilter] === 'function') {
            ;(store as any)[clearFilter]()
          }
          if (typeof (store as any)[clearRows] === 'function') {
            ;(store as any)[clearRows]()
          }
          if (typeof (store as any)[clearAdvacneFilter] === 'function') {
            ;(store as any)[clearAdvacneFilter]()
          }
        }
      )
    }
  }
}
export {}
